'use client'

import { Card, Cell, Divider, InputText, Text } from '@vinted/web-ui'

import { businessAccountFromUserDto } from '@marketplace-web/business-accounts/business-accounts-data'
import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'
import { useSession } from '@marketplace-web/shared/session-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

enum Field {
  FullName = 'businessRepresentative.fullName',
  Birthday = 'businessRepresentative.birthday',
  Nationality = 'businessRepresentative.nationality',
  Country = 'businessRepresentative.country',
}

const BusinessRepresentative = () => {
  const translate = useTranslate('profile_settings.business_representative')
  const { user } = useSession()
  const businessAccount = businessAccountFromUserDto(user)

  if (!user || !businessAccount) return null

  return (
    <Card>
      <Cell styling={Cell.Styling.Wide}>
        <Text
          as="h4"
          width={Text.Width.Parent}
          alignment={Text.Alignment.Left}
          type={Text.Type.Subtitle}
          text={translate('title')}
        />
      </Cell>
      <Cell styling={Cell.Styling.Tight}>
        <SeparatedList separator={<Divider />}>
          <Cell styling={Cell.Styling.Tight}>
            <InputText
              name={Field.FullName}
              title={translate('fields.full_name.title')}
              styling={InputText.Styling.Wide}
              value={user.real_name ?? ''}
              disabled
              onChange={() => undefined}
            />
          </Cell>
          <Cell styling={Cell.Styling.Tight}>
            <InputText
              name={Field.Birthday}
              title={translate('fields.birthday.title')}
              styling={InputText.Styling.Wide}
              value={user.birthday ?? ''}
              disabled
              onChange={() => undefined}
            />
          </Cell>
          <Cell styling={Cell.Styling.Tight}>
            <InputText
              name={Field.Nationality}
              title={translate('fields.nationality.title')}
              styling={InputText.Styling.Wide}
              value={businessAccount.nationality_title ?? ''}
              disabled
              onChange={() => undefined}
            />
          </Cell>
          <Cell styling={Cell.Styling.Tight}>
            <InputText
              name={Field.Country}
              title={translate('fields.country.title')}
              styling={InputText.Styling.Wide}
              value={businessAccount.country_title ?? ''}
              disabled
              onChange={() => undefined}
            />
          </Cell>
        </SeparatedList>
      </Cell>
    </Card>
  )
}

export default BusinessRepresentative
